<div class="badge"  [class.placeholder]="isLoading()"  [class]="getBootstrapClasses()">{{ getFormattedStatus() }}</div>
